import React from 'react';
import PropTypes from 'prop-types';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import { Type } from '@spotify-internal/encore-creator-web';
import { kebabCase } from 'lodash';
import styles from './index.module.scss';
import { trackEvent } from '../../../lib/Tracking';
import { PODCAST_SUPPORT_EMAIL } from '../../../lib/constants';
import { FAQQuestions } from './faqs';
import { FAQ } from '../../../types';

// offset anchors by the height of the top nav
configureAnchors({ offset: -80, scrollDuration: 0 });

interface Props {
  faqs: FAQ[];
}

export function Faq(props: Props) {
  React.useEffect(() => {
    trackEvent({ category: 'page-type', action: 'view', label: 'help' });
  }, []);

  return (
    <div data-qa="help-page" className={styles.wrapper}>
      {props.faqs.map(({ question, answer }) => (
        <ScrollableAnchor id={kebabCase(question)} key={question}>
          <div className={styles.question} data-testid="faq-question">
            <Type as="h1" variant={Type.heading3}>
              <a href={`#${kebabCase(question)}`}>{question}</a>
            </Type>
            <div>{answer}</div>
          </div>
        </ScrollableAnchor>
      ))}

      <Type as="p" variant={Type.body1}>
        For more feedback or questions, please reach us at{' '}
        <a href={`mailto:${PODCAST_SUPPORT_EMAIL}`}>{PODCAST_SUPPORT_EMAIL}</a>
      </Type>
    </div>
  );
}

Faq.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.node.isRequired,
      featureFlags: PropTypes.arrayOf(PropTypes.func),
    }),
  ).isRequired,
};

Faq.defaultProps = {
  faqs: FAQQuestions,
};
